import { get } from './get';
import { list } from './list';

export const workflows = {
  get,
  list,
};
